import type { RootState } from 'reducers/types';

export const getCaptchaResponse = (state: RootState) => {
  return state.ui.captcha?.response;
};

export const getCaptchaVerificationError = (state: RootState) => {
  return !!state.ui.captcha?.verificationError;
};
